<template>
  <v-menu :nudge-width="220" offset-y :nudge-left="150">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Fermenter operations</v-btn>
      <v-btn small icon v-on="on" v-on:click.prevent v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
    </template>
    <v-list dense>
      <v-list-item :to="{name:'EquipmentFermentersTransactions',params:{fermenterId:fermenter.id}}"><v-list-item-title>Transactions</v-list-item-title></v-list-item>
      <v-list-item @click="$emit('mashNotes')" v-if="fermenter.contents.mashId"><v-list-item-title>Mash notes</v-list-item-title></v-list-item>
      <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Fermenters',to:{name:'EquipmentFermenters'}}]},query:{to:'reports/inventory/ReportsLot',id:fermenter.id,lot:fermenter.contents.lot,forward:1}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
      <v-list-item v-if="company.allowAudit && company.permissions.includes('audit')" :to="{name:'Audit',query:{entityId:fermenter.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
      <template v-if="!readOnly">
        <v-divider/>
        <v-list-item :to="{name:'EquipmentFermentersReduceInventory',params:{fermenterId:fermenter.id}}"><v-list-item-title>Reduce inventory</v-list-item-title></v-list-item>
        <v-list-item :to="{name:'EquipmentFermentersTransferToFermenter',params:{fermenterId:fermenter.id}}"><v-list-item-title>Move contents to other fermenter</v-list-item-title></v-list-item>
        <v-divider/>
        <v-menu :nudge-left="240">
          <template v-slot:activator="{on:reduce}">
            <v-list-item v-on="reduce">
              <v-list-item-title>Maintenance</v-list-item-title>
              <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item v-if="!readOnly" :to="{name:'EquipmentMaintenance',params:{equipmentId:fermenter.id}}"><v-list-item-title>Perform maintenance</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'EquipmentMaintenanceLog',params:{equipmentId:fermenter.id}}"><v-list-item-title>Maintenance history</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
        <v-divider/>
        <generate-qr-code type="Fermenter" :id="fermenter.id"/>
        <v-list-item :to="{name:'EquipmentFermentersEdit',params:{fermenterId:fermenter.id}}"><v-list-item-title>Edit fermenter</v-list-item-title></v-list-item>
        <v-list-item @click="$emit('delete')"><v-list-item-title>Delete fermenter</v-list-item-title></v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import generateQrCode from '@/components/GenerateQrCode'

export default {
  name: 'EquipmentFermenterMenu',
  components: {generateQrCode},
  props: {
    fermenter: {type:Object, required:true},
    readOnly: {type:Boolean, required:false, default:false}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  }
}
</script>